import { MenuItem, Select, SelectChangeEvent } from "@mui/material";
import React from "react";
import DKFormInputLabelContainer from "../widgets/formVariablesWidget/formInputContainer/DKFormInputLabelContainer";
import { uid } from "../../../helpers/utilsTS";

type Value = string | number | boolean;

type DKFormSelectProps = {
  dataTestId?: string;
  label: string;
  selectedValue: Value;
  onChange: (e: SelectChangeEvent) => void;
  items: { value: Value; label: string }[];
};

const DKFormSelect = ({
  dataTestId,
  label,
  selectedValue,
  onChange,
  items = [],
}: DKFormSelectProps) => {
  return (
    <DKFormInputLabelContainer label={label}>
      <Select
        data-testid={dataTestId}
        value={selectedValue?.toString()}
        labelId="label"
        id="select"
        onChange={onChange}
        sx={{
          width: "100%",
        }}
        MenuProps={{
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
          },
          transformOrigin: {
            vertical: "top",
            horizontal: "left",
          },
        }}
      >
        {items.map((item) => {
          return (
            <MenuItem value={item.value?.toString()} key={uid.rnd()}>
              {item.label}
            </MenuItem>
          );
        })}
      </Select>
    </DKFormInputLabelContainer>
  );
};

export default DKFormSelect;
